const historyDefaultValue = [];
const historyKey = 'listing-history';
const historyMaxEntries = 6;

import axios from 'axios';
import { camelizeKeys } from 'humps';
import {
  getListingDetailsCache,
  setListingDetailsCache,
  checkAndClearCacheIfLanguageChanged,
} from './listingCache';
import endpoints from '../define/endpoints';

// Reading the stored ids is synchronous, and a render path that has to decide
// what to paint cannot wait a tick for it.
export const getHistorySync = () => {
  try {
    return JSON.parse(localStorage.getItem(historyKey)) || historyDefaultValue;
  } catch (e) {
    return historyDefaultValue;
  }
};

export const getHistory = () => Promise.resolve(getHistorySync());

export const setHistory = (history) => {
  return new Promise((resolve) => {
    try {
      localStorage.setItem(historyKey, JSON.stringify(history));
    } finally {
      resolve();
    }
  });
};

export const historyAddCommand = async ({ listingId }) => {
  const prevHistory = await getHistory();

  let newHistory = prevHistory.filter((entry) => entry !== listingId);
  newHistory.unshift(listingId);
  newHistory = newHistory.slice(0, historyMaxEntries);

  await setHistory(newHistory);

  // Check if language changed and clear cache if needed
  await checkAndClearCacheIfLanguageChanged();

  // Update the cache
  const cache = await getListingDetailsCache();
  const now = Date.now();

  // Fetch details for the new listing
  try {
    const res = await axios.get(`${endpoints.core}/listings`, {
      params: {
        id: listingId,
        locale: window.freedomeConfig.locale,
      },
    });
    const data = camelizeKeys(res.data);
    const listingDetails = data[0] || {};

    // Update cache with new listing details
    cache[listingId] = {
      details: listingDetails,
      timestamp: now,
    };

    // Remove cache entries not in the current history
    const updatedCache = {};
    newHistory.forEach((id) => {
      if (cache[id]) {
        updatedCache[id] = cache[id];
      }
    });
    // Add the new listing if not already included
    updatedCache[listingId] = cache[listingId];

    await setListingDetailsCache(updatedCache);
  } catch (error) {
    // console.error('Error fetching listing details for cache:', error);
  }

  return newHistory;
};

export const historyLoadCommand = async () => {
  return await getHistory();
};
